import useAxios from "../../../../hooks/useAxios";
import useLoading from "../../../../shared/components/loading/useLoading";
import { useEffect, useRef, useState } from "react";
import {
  API_PERMISSIONS,
  API_PERMISSIONS_BY_ID,
  API_PERMISSIONS_DATAAPI,
  API_PERMISSIONS_DATAAPI_BY_ID,
  DROPDOWNS_DATASETS,
  DROPDOWNS_ROLES,
} from "../../../../shared/lib/apiEndpointsResolver";
import { catchFunction } from "../../../../shared/lib/utils";
import SearchInput from "../../../../shared/components/input/SearchInput";
import OverviewTabContent from "../../../../shared/components/overview-panel/OverviewTabContent";
import OverviewComponent from "../../../../shared/components/overview-panel/OverviewComponent";
import DataApiPermissionsTable from "./DataApiPermissionsTable";
import CreateDataApiPermissionDialog from "./create/CreateDataApiPermissionDialog";
import useToastWrapper from "../../../../hooks/useToastWrapper";
import useConfirmDialog from "../../../../shared/components/confirm-dialog/useConfirmDialog";

const DataApiPermissionsOverview = () => {
  const axios = useAxios();
  const { setLoading } = useLoading();
  const [permissions, setPermissions] = useState([]);
  const permissionsRef = useRef([]);
  const [roles, setRoles] = useState([]);
  const [datasets, setDatasets] = useState([]);
  const toast = useToastWrapper();
  const deletePermissionDialog = useConfirmDialog();
  const [permissionForDeletion, setPermissionForDeletion] = useState();
  const breadcrumbItems = [{ title: "Permisos Data API" }];

  const findPermissions = () => {
    setLoading(true);
    axios
      .get(`${API_PERMISSIONS}?app=data-api-service`)
      .then((response) => {
        setPermissions(response.data);
        permissionsRef.current = response.data;
      })
      .catch(catchFunction)
      .finally(() => setLoading(false));
  };

  const findRolesDropdown = () => {
    axios
      .get(DROPDOWNS_ROLES)
      .then((response) => setRoles(response.data))
      .catch(catchFunction);
  };

  const findDatasetsDropdown = () => {
    axios
      .get(DROPDOWNS_DATASETS)
      .then((response) =>
        setDatasets(
          response.data.map((x) => ({ label: x.code, value: x.code })),
        ),
      )
      .catch(catchFunction);
  };

  const filterPermissions = (searchEvent) => {
    const term = searchEvent.target.value.toLowerCase();
    setPermissions(
      permissionsRef.current.filter(
        (x) =>
          x.role.name.toLowerCase().includes(term) ||
          x.key.toLowerCase().includes(term),
      ),
    );
  };

  const onPermissionCreation = (formValues) => {
    axios
      .post(API_PERMISSIONS_DATAAPI, formValues)
      .then((response) => {
        toast.success(
          `Creado nuevo permiso para el rol ${response.data.role.name} en el dataset ${response.data.key}`,
        );
        findPermissions();
      })
      .catch(catchFunction)
      .finally(() => setLoading(false));
  };

  const deletePermission = () => {
    axios
      .delete(API_PERMISSIONS_BY_ID(permissionForDeletion.id))
      .then((_) => {
        toast.success(
          `Eliminado permiso del rol ${permissionForDeletion.role.name} en el dataset ${permissionForDeletion.key}`,
        );
        findPermissions();
      })
      .catch(catchFunction);
  };

  const onDeletePermissionClick = (id) => {
    const permission = permissionsRef.current.filter((x) => x.id === id)[0];
    setPermissionForDeletion(permission);
    deletePermissionDialog.display(
      `permiso del rol ${permission.role.name} en el dataset ${permission.key}`,
    );
  };

  const onPermisionEdition = (id, formValues) => {
    axios
      .put(API_PERMISSIONS_DATAAPI_BY_ID(id), formValues)
      .then((response) => {
        toast.success(`Permiso ${response.id} modificado correctamente`);
        findPermissions();
      })
      .catch(catchFunction);
  };

  const OverviewOptions = (
    <>
      <SearchInput
        onChangeHandler={filterPermissions}
        placeholder="Filtrar por rol o dataset"
      />
      <CreateDataApiPermissionDialog
        onSubmitHandler={onPermissionCreation}
        roles={roles}
        datasets={datasets}
      />
    </>
  );

  const permissionsTabs = [
    {
      trigger: { value: "all", label: "Todos" },
      content: (
        <OverviewTabContent
          value="all"
          title="Listado de permisos"
          description="Listado completo de todos los permisos de Data API"
        >
          <DataApiPermissionsTable
            data={permissions}
            onDelete={onDeletePermissionClick}
            onEdition={onPermisionEdition}
            roles={roles}
            datasets={datasets}
          />
        </OverviewTabContent>
      ),
    },
  ];

  useEffect(() => {
    findPermissions();
    findRolesDropdown();
    findDatasetsDropdown();
  }, []);

  return (
    <>
      {deletePermissionDialog.renderSafeDialog(deletePermission)}
      <OverviewComponent
        breadcrumbItems={breadcrumbItems}
        options={OverviewOptions}
        tabs={permissionsTabs}
      />
    </>
  );
};

export default DataApiPermissionsOverview;
